import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { apiV2Query } from "../../utils/api-config";
import { Response } from "../../types/response/Response";
import { PrintCalculateDTO } from "../../types/print/PrintCalculateDTO";
import { PrintCreateDTO } from "../../types/print/PrintCreateDTO";
import { PrintType } from "../../types/products/ProductDTO";
import {
  PrintRequestParams,
  PrintsPageableDTO,
} from "../../types/print/PrintDTO";
import { convertParam } from "../../types/utils/Constants";

export const printApiV2 = createApi({
  reducerPath: "printV2",
  baseQuery: apiV2Query,
  tagTypes: [
    "printCategories",
    "prints",
    "notification",
    "accounts-notification",
  ],
  endpoints: (builder) => ({
    calculatePrint: builder.mutation<
      Response<PrintCalculateDTO>,
      Partial<number | undefined>
    >({
      query: (product_id) => `/prints/product/${product_id}/calculate`,
    }),
    calculateExistingPrint: builder.mutation<
      Response<PrintCalculateDTO>,
      Partial<number | undefined>
    >({
      query: (print_id) => `/prints/${print_id}/calculate`,
    }),
    getPrints: builder.query<
      Response<PrintsPageableDTO>,
      Partial<PrintRequestParams>
    >({
      query: (param) =>
        `/prints?account_id=${param.account_id}&page=${param.page}&size=${
          param.size
        }${convertParam("types", param.types)}`,
      providesTags: ["prints"],
    }),
    createPrint: builder.mutation<void, Partial<PrintCreateDTO>>({
      query: (body) => ({
        url: "/prints",
        method: "POST",
        body,
      }),
      invalidatesTags: ["prints"],
    }),
    getPrintsType: builder.query<Response<PrintType[]>, void>({
      query: () => "/prints/types",
      providesTags: ["prints"],
    }),
  }),
});

export const {
  useCalculatePrintMutation,
  useCalculateExistingPrintMutation,
  useGetPrintsQuery,
  useGetPrintsTypeQuery,
  useLazyGetPrintsQuery,
  useCreatePrintMutation,
} = printApiV2
